module.exports = __webpack_public_path__ + "img/homepage-quick-links-ford.96ada572.jpg";